<template>
  <div class="callall">
    <div class="calltop">
      <span class="callbtn" @click="callcut('cut')">取消</span>
      <span style="font-size:18px;">呼叫</span>
    </div>
    <div class="callstyle">
      {{callstyle}}
    </div>
    <div class="calltime">
      {{calltime}}
    </div>
    <div class="callnum">
      {{callnum}}
    </div>
    <div class="keyword">
      <span v-for="(item,index) in callkey" :keys="index" :id="'cd'+item.key" :class="{'mid': (item.key ==2 || item.key ==5 || item.key ==8 ||item.key ==0)}" @touchstart ="cdown('cd'+item.key)" @touchend="cup('cd'+item.key)" @click="keygo(item.voicePath,item.key,item.action,item.id,item.teamId,item)">
          {{item.key}}
      </span>
    </div>
     <div class="callclose">
        <img v-if="callis" src="/pc/static/assets/callcut.png" @click="callcut('cut')">
        <img v-else src="/static/assets/callclose.png" @click="callcut('no')">
    </div>
    <audio id="remoteAudioMedia" autoplay ></audio>
    <audio id='ding' src='/pc/static/video/ding.mp3' hidden='true'></audio>
    <audio id="linevideo" :src="linevideo" hidden='true'></audio>
    <audio id='callvideov' :src='callvideosrc' hidden='true' ></audio>
    <audio id='waitvideo' :src='waitvideo' hidden='true' ></audio>
    <audio id='errorvideo' :src='errorvideo' hidden='true'></audio>
    <audio id='quesvideo' :src='quesvideo' hidden='true'></audio>
    <audio id="noservice" :src="noservicevideo" hidden='true'></audio>
    <audio id="modevoice" hidden='true'></audio>
    <audio id="robotreplace" src="/pc/static/video/robotreplace.mp3" hidden='true'></audio>
    <audio id="answerwrong" src="/pc/static/video/answerlwrong.mp3" hidden='true'></audio>
    <audio id="robotreplace" src="/pc/static/video/robotreplace.mp3" hidden='true'></audio>
    <audio id="phoneanswer" src="/pc/static/video/robotreplace.mp3" hidden='true'></audio>
    <audio id="noanswer" src="/pc/static/video/noanewer.mp3" hidden='true'></audio>
  </div>
</template>

<script>
  import recorder from '../../assets/video/recorder'
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import * as io from 'socket.io-client'
  import {Socket} from 'socket.io-client'
  import axios from '@/utils/request.js'
  import * as Urls from '../../components/url'
  export default{
    data(){
      return {
        boxBodyColor:'',
        satisfyMode:1,
        //visitor.one.cn:8083
        baseVisitorUrl:Urls.baseurl+'/api',
        callis:true,
        //每一层的开始语音
        callvideo:'',
        audio:"",
        callstyle: '通话中',
        calltime: "00:00:00",
        callnum:'',
        //满意度语音
        modevoicevideo:'',
        //非服务时间语音
        noservicevideo:'',
        //排队时语音 
        linevideo:'',
        //排队时间
        linetime:'',
        //排队次数
        linemmax:'',
        //排队播放语音定时器
        linetimer:'',
        //等待是语音
        waitvideo:'',
        //错误是语音
        errorvideo:'',
        //播放的语音
        quesvideo:'',
        callvideosrc:'',
        //上一层
        callkey:[
              {"key":1,"action":"error","id":"","teamId":""},
              {"key":2,"action":"error","id":"","teamId":""},
              {"key":3,"action":"error","id":"","teamId":""},
              {"key":4,"action":"error","id":"","teamId":""},
              {"key":5,"action":"error","id":"","teamId":""},
              {"key":6,"action":"error","id":"","teamId":""},
              {"key":7,"action":"error","id":"","teamId":""},
              {"key":8,"action":"error","id":"","teamId":""},
              {"key":9,"action":"error","id":"","teamId":""},
              {"key":'*',"action":"error","id":"","teamId":""},
              {"key":0,"action":"error","id":"","teamId":""},
              {"key":"#","action":"error","id":"","teamId":""}
        ],
        //层数轨迹给返回上一层使用
        callkeyarr:[],
        videohisarr:[],
        timer:'',
        status:'ivr',
        callid:'',
        queuetimer:'',
        rtc:'',
        md5:'',
        //会话数据
        rtcobj:{},
        evaluateType:'',
        socket:'',
        evaluis:'',
        statuslevel:'ivr',
        createtime:'',
        nowproid:'',
        nowteamid:'',
        recorder:'',
        wrongtimes:0,
        keyris:false,
        linestyle:1
      }
    },
    computed:{
      ...mapGetters({
        'endis' : 'endclass',
        'getsocket' : 'getsocket'
      })
    },
    beforeDestroy :function(){
      clearInterval(this.linetimer);
      clearInterval(this.queuetimer);
      if( this.socket!=""){
         this.socket.disconnect();
      }
      if(this.timer!=''){
        console.log("清除定时器");
        clearInterval(this.timer)
      }

    },
    methods: {
      recordstart(){
          this.listreload("record");
          var vm = this;
          this.recorder = new Recorder({
              sampleRate: 16000, //采样频率，默认为44100Hz(标准MP3采样率)
              bitRate: 16, //比特率，默认为128kbps(标准MP3质量)
              success: function(){ //成功回调函数
                  
              },
              error: function(msg){ //失败回调函数
                  alert(msg);
              },
              fix: function(msg){ //不支持H5录音回调函数
                  alert(msg);
              }
          });
      },
      rtcend(){
        console.log("-----------关闭推流");
          this.rtc.stopRTC({}, function(data){

              //成功
              console.log("成功");

          },function(){
              //失败
              console.log("失败");
          });
       },
       rtcgo(){
          console.log("打开推流")
          this.rtc.startRTC({}, function(){

            //成功
            console.log("打开成功");

        },function(){
            //失败
            console.log("失败");
        });
      },
      getSatisfySetting () {
        let vm = this
        let visitorMd5Code = vm.$route.query.v;
        api.getSatisfySetting(visitorMd5Code, function (body) {
          if (body.code === 1) {
            vm.satisfyMode = body.data.mode
          }
        })
      },
      cresocket(){
        var vm  = this;
        if (vm.$store.state.im.socket instanceof Socket) {
          // 如果已经存在了就断开原来的链接

          vm.$store.state.im.socket.disconnect();
          console.log("存在连接");
        }

        var locdat='';
        var websocktUrl = process.env.API_WEBSOCKETURL
        if(sessionStorage.getItem("locdat")){
          console.log("有uuid")
          locdat=sessionStorage.getItem("locdat")
        }else{
          locdat=new Date();
          console.log("无uuid")
          locdat=locdat.getTime();
          sessionStorage.setItem("locdat",locdat)

        }

        this.socket = io.connect(websocktUrl + vm.md5+"&uuid="+locdat,{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true});




        this.socket.on(this.md5, function (data) {
          if(data.imMsgHeader){
            var imMsgHeader= data.imMsgHeader;
            if(imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'EVALUATE_NOTIFY' && imMsgHeader.sessionType==4){
              //推送评价
              console.log("推送评价");
              var line1 =document.getElementById("modevoice");
              setTimeout(function(){
                console.log(line1)
                line1.currentTime = 0;
                line1.play();
              },10)

              vm.listreload("notify");
              vm.callcut("evalute");
            }else if (imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'FORCE_HANG' && imMsgHeader.sessionType==4) {
              //收到关闭会话
              console.log("强制挂断");
              vm.callcut('cut');
            }else if (imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'TRANSTER_NOTIFY' && imMsgHeader.sessionType==4) {
              console.log("收到转接通知");
              var wait = document.getElementById("waitvideo");
              wait.currentTime = 0;
              wait.play();

            }else if (imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'TRANSTER_CONFIRM' && imMsgHeader.sessionType==4) {
              console.log("收到转接确认");
              var wait = document.getElementById("waitvideo");
              wait.pause();

            }else if (imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'PUSH_STREAM_NOTIFY' && imMsgHeader.sessionType==4) {
              console.log("收到重新推流");
              //location.reload()

            }
          }
        })
      },
      callback(){
        // if (window.rampage) {
        //   window.rampage.actionClose();
        // } else {
          console.warn('window.rampage对象不存在 即将调用返回方法')
          window.history.back()

        //}
      },
      keygo(path,key,action,id,teamid,item){
        var vm = this;
        console.log(item)
        if(vm.statuslevel == 'ivr' && id && id != ""){
          console.log('当前操作id为：'+id);
          axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/opt?visitorMd5Code='+vm.md5+'&flowCfgDetailId='+id).then(function (resp) {
              console.log('传到生成会话记录')
              console.log(resp)
              
          });
        }

        this.callnum = this.callnum+key;
        this.audio.play();
        vm.callvideo.load();
        var dom=document.getElementById('errorvideo');
        dom.load();
        var quesvideo=document.getElementById('quesvideo');
        quesvideo.load();
        var callvideov= document.getElementById('callvideov');
        callvideov.load();
        var answerwrong= document.getElementById('answerwrong');
        answerwrong.load();
        var phoneanswer= document.getElementById('phoneanswer');
        phoneanswer.load();
        var vid = document.getElementById("robotreplace");
        vid.load();
        if(action == "error"){
          console.log('播放错误语音')
          var dom=document.getElementById('errorvideo');
          dom.currentTime = 0;
          dom.play();
        }else if (action == "4") {
          console.log('重新播放语音');
          this.callvideo.currentTime = 0;
          this.callvideo.play();
        }else if (action == "3") {
          console.log('播放语音')
          this.quesvideo = path;

          var quesvideo=document.getElementById('quesvideo');
          console.log(quesvideo);
          setTimeout(function(){
            quesvideo.currentTime = 0;
            quesvideo.play();
          },10)

        }else if (action == "1") {
          console.log('进入下级导航');
          console.log(id);
          //存入菜单缓存
          this.callkeyarr.push(this.callkey);
          this.videohisarr.push(this.callvideosrc);

          this.callvideosrc = path;
          //console.log(path);

          setTimeout(function(){
            vm.callvideo.currentTime = 0;
            vm.callvideo.play();
          },10)


          this.listreload();
          this.getbtnlist(id);

          //进入下级导航
        }else if (action == "5") {
          //进入上级导航
          console.log('进入上级导航');

          this.callkey = this.callkeyarr[this.callkeyarr.length-1];

          this.callkeyarr.splice(this.callkeyarr.length-1, 1);

          this.callvideosrc = this.videohisarr[this.videohisarr.length-1];
          this.videohisarr.splice(this.videohisarr.length-1, 1);
          setTimeout(function(){
            vm.callvideo.currentTime = 0;
            vm.callvideo.play();
          },10)

        }else if (action == "2") {
          console.log('分配客服')
          console.log(teamid)
          vm.listreload();
          axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/close?visitorMd5Code='+vm.md5).then(function (resp) {
            console.log('进入会话结束ivr');
            console.log(resp.data);
          })
          if(item.productId && item.productId!=''){
            
            this.nowproid = item.productId;
            this.nowteamid = teamid;
            var vid = document.getElementById("robotreplace");
            //vid.volume = 0.2;
            vid.currentTime = 0;
            vid.play();
            this.recordstart();
          }else{
            this.linestyle = 1;
            this.linego(teamid);
          }
        }else if (action == "notify") {
          console.log("评价会话");
          console.log(key);
          var obj={};
          obj.mode = 3;
          obj.basicLevel = key;
         axios.post(vm.baseVisitorUrl + '/visitor/call-center/runtime/call/evaluate?visitorMd5Code='+vm.md5+'&sessionId='+vm.callid, obj).then(function (resp) {
            if(resp.data.code==1){
              vm.$message.success('评价成功！');
              vm.listreload();
              vm.callback();
            }
          }, function (errorMessage) {
            vm.$message.error('网络异常，请稍后再试');
          })
        }else if(action == "6"){
          this.callvideo.pause();
          window.open(item.url); 
        }else if(action == "recordgo"){
          // this.nowvideoid.pause();
          this.keyris=true;
          this.recorder.start();
        }else if (action == "recordend") {
          if(this.keyris){

              this.recorder.stop();
              this.recorder.getBlob(function(blob){
                  const formData = new FormData();
                  // var file = document.getElementById("record0").files[0];
                  // formData.append('file', file)
                  formData.append('file', blob)
                  console.log(blob);
                  console.log('--------------------------------')
                  axios.post(vm.baseVisitorUrl+'/visitor/call-center/ivr/spirit/speech?productId='+vm.nowproid+'&visitorMd5Code='+vm.md5,formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }

                  }).then(function(res){
                    console.log(res);
                    var data = res.data;
                    if(data.code == 1 && data.data.questionId != '0'){
                      console.log('问题命中了ok');
                      vm.videospritis(1);
                      if(data.data.answerRecordUrl){
                        console.log('问题命中了');
                        vm.reurl(data.data.answerRecordUrl);
                      }
                      
                    }else if(data.code== 70505){
                      if(vm.wrongtimes < 1){
                        console.log('播放质量过差音频！');
                        var vid = document.getElementById("answerwrong");
                        vid.currentTime = 0;
                        vid.play();
                        vm.wrongtimes++;
                      }else{
                        console.log('进入人工');
                        vm.videospritis(2);
                        vm.linestyle = 2;
                        vm.linego(vm.nowteamid);
                      }
                      
                    }else {
                      console.log('进入人工');
                      vm.linestyle = 2;
                      vm.videospritis(2);
                      vm.linego(vm.nowteamid);
                    }
                  })
                  
              });
              this.keyris = false;

          }else{
            var dom=document.getElementById('errorvideo');
            dom.currentTime = 0;
            dom.play();
          }
        }
      },
      //通知精灵是否解决问题 1:解决 2，未解决
      videospritis(sty){
        if(sty == 1){
          var url  =this.baseVisitorUrl+ '/visitor/spirit/solved?visitorMd5Code='+this.md5;
        }else{
          var url  =this.baseVisitorUrl+ '/visitor/spirit/unSolved?visitorMd5Code='+this.md5;
        }
        axios.get(url).then(function (resp) {
        }, function (errorMessage) {
          alert('提示', '网络异常，请稍后再试');
        })
      },
      // 获取音频url
      reurl(url){
        var vm  = this;
        //Vue.http.get().then(function(res){
          
          var res = '//visitor.one.cn/api/visitor/call-center/ivr/spirit/speech/download?answerRecordUrl='+url+'&visitorMd5Code='+vm.md5;
          console.log(res);
          var phoneanswer = document.getElementById("phoneanswer");
          phoneanswer.src = res;
          
          //phoneanswer.onloadedmetadata =function(){
            console.log('开始播放！')
            phoneanswer.currentTime = 0;
            phoneanswer.play();
          //}
      },
      cdown(id){
        var dom=document.getElementById(id);
        dom.style = 'background: #808080;color: #fff;';

      },
      cup(id){
        var dom=document.getElementById(id);
        dom.style = 'background: #b4dad9;color: #3f686f;';

      },
      //挂断电话
      callcut(cls){
        var vm =this;
        if(cls == "cut"){
          if(this.rtc != ""){
            this.rtcend();
            this.rtc.quit({
                roomid : vm.rtcobj.audioRoomId,
                role : "user",
                privateMapKey:vm.rtcobj.privateMapKey,
            }  ,function(){
                //退出成功
                axios.get(vm.baseVisitorUrl+'/visitor/call-center/runtime/call/ended?sessionId='+vm.callid+'&reason=visitorcut'+"&visitorMd5Code="+vm.md5+"&closeType=0").then(function (resp) {
                  var data  = resp.data;
                  if(data.code == 1){
                    vm.callback();
                    console.log('发送结束会话成功');
                  }
                })
            } , function(){
                //退出失败
            } );
          }else {
            if(vm.callid!=''){
              axios.get(vm.baseVisitorUrl+'/visitor/call-center/runtime/call/cancel?sessionId='+vm.callid+'&reason=visitorcut'+"&visitorMd5Code="+vm.md5).then(function (resp) {
                var data  = resp.data;
                if(data.code == 1){
                  vm.callback();
                  console.log('发送取消排队成功');
                }
              })
            }

            this.callback();
          }

          if(vm.statuslevel == 'ivr'){
            axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/close?visitorMd5Code='+vm.md5).then(function (resp) {
              console.log('结束ivr');
              console.log(resp)
            })
          }else{
            console.log('session结束ivr');
          }

        }else if(cls == "evalute"){
          console.log('满意度结束')
          if(this.rtc != ""){
            this.rtcend();
            this.rtc.quit({
                roomid : vm.rtcobj.audioRoomId,
                role : "user",
                privateMapKey:vm.rtcobj.privateMapKey,
            }  ,function(){
                //退出成功
                axios.get(vm.baseVisitorUrl+'/visitor/call-center/runtime/call/ended?sessionId='+vm.callid+'&reason=visitorcut'+"&visitorMd5Code="+vm.md5+"&closeType=3").then(function (resp) {
                  var data  = resp.data;
                  if(data.code == 1){
                    console.log('发送满意度结束会话成功');
                    vm.rtc = '';
                  }
                })
            } , function(){
                //退出失败
            } );
          }
        }
      },
      timechange(time){
        var h = parseInt(time/3600);
        var m = parseInt(time%3600/60);
        var s = time%3600%60;
        if(h<10){
            h="0"+h;
          }
          if(m<10){
            m="0"+m;
          }
          if(s<10){
            s="0"+s;
          }
          console.log(this.calltime)
         this.calltime=h+":"+m+":"+s;
      },
      //定时器计时时间
      alltime(){
        var vm=this;
        this.timer=setInterval(function(){
          //console.log(vm.calltime);
          var alltime=vm.calltime.split(":");
          var h=alltime[0]-0;
          var m=alltime[1]-0;
          var s=alltime[2]-0;
          s=s+1;
          if(s==60){
            s=0;
            m=m+1;
          }
          if(m==60){
            m=0;
            h=h+1;
          }
          if(h<10){
            h="0"+h;
          }
          if(m<10){
            m="0"+m;
          }
          if(s<10){
            s="0"+s;
          }
          vm.calltime=h+":"+m+":"+s;
        },1000)
      },
      //链接通话
      callconnect(){
        var vm = this;
        vm.callvideo=document.getElementById("callvideov");
        vm.audio=document.getElementById("ding");

        

        axios.get(vm.baseVisitorUrl+'/visitor/call-center/runtime/session/find?sessionId='+vm.callid+"&visitorMd5Code="+this.md5+"&ivrStartTime="+this.createtime).then(function (resp) {
            var data  = resp.data;
            if(data.code == 1){
              var obj = data.data;
              vm.callid = obj.sessionId;
              vm.rtcobj = obj;

              vm.callid  = obj.sessionId;
              if(vm.createtime != ""){
                if(vm.timer!=''){
                  console.log("清除定时器");
                  clearInterval(vm.timer)
                }
                vm.timechange(obj.callDuration/1000);
                vm.alltime();
              }
              
              vm.cresocket();
              //console.log(obj);
              vm.rtc = new WebRTCAPI({
                  userId:obj.visitorAudioId,
                  sdkAppId:obj.sdkAppId,
                  accountType:obj.accountType,
                  userSig:obj.visitorAudioSig,
                  closeLocalMedia: true,
                  video: false
              },function(){
                  //初始化化成功回调
                  console.log( ' 初始化化成功回调 ');
                  //进入房间
                  vm.rtc.createRoom({
                      roomid : obj.audioRoomId,
                      role : "user",
                      privateMapKey:obj.visitorPrivateMapKey,
                      pureAudioPushMod:2,
                      recordid:obj.audioRoomId
                  },function(data){
                      console.log( ' 进房房间成功 ',data);
                      vm.rtcgo();
                      vm.callstyle = "通话中";
                      //发送开始通话
                      axios.get(vm.baseVisitorUrl+'/visitor/call-center/runtime/call/start?sessionId='+vm.callid+'&reason=ok'+"&visitorMd5Code="+vm.md5).then(function (resp) {
                        var data  = resp.data;
                        if(data.code == 1){
                          console.log('发送通话开始成功');
                        }
                      })

                  } ,  function(error){
                      console.log( ' 进入房间失败 ' , error);
                  });

                  // //本地流 新增
                  // vm.rtc.on("onLocalStreamAdd", function(data){
                  //     if( data && data.stream){

                  //          document.querySelector("#localAudioMedia").srcObject = data.stream;
                  //     }
                  // });
                  //远端流 新增/更新
                  vm.rtc.on("onRemoteStreamUpdate", function(data){
                    console.log("videoId为："+data.videoId);
                      if( data && data.stream){

                          document.querySelector("#remoteAudioMedia").srcObject = data.stream;
                      }
                  });
                  //var errorCodeMap = WebRTCAPI.fn.getErrorCode();
                  //监听错误事件通知
                  vm.rtc.on( 'onErrorNotify' , function(info){
                      console.log(info);
                  })
                    

              },function(error){
                  //alert(error)
                  console.log( error );
              });




            }else{
                vm.listreload();
                vm.getbtnlist(0);


            }
          }, function (errorMessage) {
            vm.$message.error('网络异常，请稍后再试');
          })

          
      },

      //定时获取排队状态
      calltimer(){
        var vm = this;
        this.queuetimer = setInterval(function(){
          axios.get(vm.baseVisitorUrl+'/visitor/call-center/runtime/call/queue-position?sessionId='+vm.callid+"&visitorMd5Code="+vm.md5).then(function (resp) {
            var data  = resp.data;
            vm.callstyle = "正在呼叫客服";
            if(data.code == 1){
              if(data.data.sessionStatus == "chatting"){
                clearInterval(vm.queuetimer);
                clearInterval(vm.linetimer);
                vm.callstyle = "通话中";
                vm.callconnect();
              }else if (data.data.sessionStatus == "ended") {
                clearInterval(vm.queuetimer);
              }
            }else{
              vm.$message.error('排队失败');
            }
          }, function (errorMessage) {
            vm.$message.error('网络异常，请稍后再试');
          })
        },3000);
        var rime = 1;
        if(vm.linestyle == 1){
          var line =document.getElementById("linevideo");
        }else{
          var line =document.getElementById("noanswer");
        }
        
        line.currentTime = 0;
        line.play();
        this.linetimer = setInterval(function(){

          console.log("等待次数:"+rime);
          console.log(vm.linemmax);
          console.log((vm.linetime*1+3)*1000);
          if(rime <= vm.linemmax){
            line.play();
            rime++;
          }else{
            clearInterval(vm.linetimer);
            vm.callcut('cut');

          }

        },(vm.linetime*1+3)*1000);

      },
      //排队ok
      linego(teamid){
        var vm = this;
        var visitorinfo = JSON.parse(sessionStorage.getItem("thisuserinfo"));
        var obj={};
        obj.teamId=teamid;
        obj.entranceId='';
        if(visitorinfo){
          obj.os= visitorinfo.os;
          obj.platform=5;
          obj.pushId='';
          obj.vipLevel=visitorinfo.vip;
          obj.account =visitorinfo.account;
          console.log("解码码的账号信息:",  obj.account);
        } 
        axios.post(vm.baseVisitorUrl+'/visitor/call-center/runtime/call/enqueue?visitorMd5Code='+this.md5,obj).then(function (resp) {
          var data  = resp.data;
          if(data.code == 1){
            vm.callid = data.data.sessionId;
            console.log(vm.callid);
            vm.calltimer();
          }else{
            vm.$message.error('排队失败');
          }
        }, function (errorMessage) {
          vm.$message.error('网络异常，请稍后再试');
        })
      },
      //
      getbtnlist(id){
        var vm = this;
        //获取语音列表
        axios.get(this.baseVisitorUrl+'/visitor/call-center/ivr/flow/detail?visitorMd5Code='+this.md5+"&id="+id).then(function (resp) {
            var data  = resp.data;
            if(data.code == 1){
              //alert(1)
              if(id==0){
                 //初始化
                  vm.$message('拨打客服电话时如有电话进入则通话将被挂断！');
                //vm.alltime();
                var obj = data.data;
                vm.callvideosrc = obj[0].voicePath;
                if(obj[0].action !="2"){
                  setTimeout(function(){
                    var dom = document.getElementById("callvideov");
                    axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/opt?visitorMd5Code='+vm.md5+'&flowCfgDetailId='+obj[0].id).then(function (resp) {
                        console.log('生成会话记录')
                        
                    });
                    dom.currentTime = 0;
                    dom.play();
                  },500)
                }


                var arr =  obj[0].list;
                if(obj[0].action =="2"){
                  setTimeout(function(){
                    axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/opt?visitorMd5Code='+vm.md5+'&flowCfgDetailId='+obj[0].id).then(function (resp) {
                        console.log('生成会话记录')
                        
                    });
                    if(obj[0].productId && obj[0].productId!=''){
                      // console.log( this.nowvideoid)
                      // vm.nowvideoid.pause();
                      vm.nowproid = obj[0].productId;
                      vm.nowteamid = obj[0].teamId;
                      var vid = document.getElementById("robotreplace");
                      //vm.nowvideoid = vid;
                      //vid.volume = 0.2;
                      vid.currentTime = 0;
                      vid.play();
                      vm.recordstart();
                    }else{
                      vm.linestyle = 1;
                      vm.linego(obj[0].teamId);
                    }

                  },500)
                }
              }else{
                var arr =  data.data;
              }
              //console.log(data.data);
              clearInterval(vm.timer)
              vm.createtime = data.createTime;
              vm.timechange(data.startTime*1);
              //console.log('时间为：'+data.startTime)
              vm.alltime();

              arr.forEach( function(element, index) {

                if(element.presskey == "*"){
                  vm.callkey[9].action = element.action;
                  vm.callkey[9].voicePath = element.voicePath;
                  vm.callkey[9].id = element.id;
                  if(element.action == "1"){
                  //console.log(vm.callkey[element.presskey-1])
                    vm.callkey[9].id = element.id;
                  }
                  if(element.action == "2"){
                    vm.callkey[9].teamId = element.teamId;
                    if(element.hasRobot){
                      vm.callkey[9].productId = element.productId;
                    }
                  }
                   if(element.action == "6"){
                      vm.callkey[9].url = element.url;
                    }
                }else if (element.presskey == "#") {
                  vm.callkey[11].action = element.action;
                  vm.callkey[11].voicePath = element.voicePath;
                  vm.callkey[11].id = element.id;
                  if(element.action == "1"){
                  //console.log(vm.callkey[element.presskey-1])
                    vm.callkey[11].id = element.id;
                  }
                  if(element.action == "2"){
                    vm.callkey[11].teamId = element.teamId;
                    if(element.hasRobot){
                      vm.callkey[11].productId = element.productId;
                    }
                  }
                   if(element.action == "6"){
                      vm.callkey[11].url = element.url;
                    }
                }else if (element.presskey == "0") {
                  vm.callkey[10].action = element.action;
                  vm.callkey[10].voicePath = element.voicePath;
                  vm.callkey[10].id = element.id;
                  if(element.action == "1"){
                  //console.log(vm.callkey[element.presskey-1])
                    vm.callkey[10].id = element.id;
                  }

                  if(element.action == "2"){
                    vm.callkey[10].teamId = element.teamId;
                    if(element.hasRobot){
                      vm.callkey[10].productId = element.productId;
                    }
                  }
                   if(element.action == "6"){
                      vm.callkey[10].url = element.url;
                    }
                }else{

                   vm.callkey[element.presskey-1].action = element.action;
                   vm.callkey[element.presskey-1].voicePath = element.voicePath;
                   vm.callkey[element.presskey-1].id = element.id;
                   if(element.action == "1"){
                      //console.log(vm.callkey[element.presskey-1])
                      vm.callkey[element.presskey-1].id = element.id;
                    }
                    if(element.action == "2"){
                      vm.callkey[element.presskey-1].teamId = element.teamId;
                      if(element.hasRobot){
                        vm.callkey[element.presskey-1].productId = element.productId;
                      }
                    }
                     if(element.action == "6"){
                      vm.callkey[element.presskey-1].url = element.url;
                    }
                }


              });
              //console.log(vm.callkey)
            }else if(data.code == 70109){
              
              
              setTimeout(function(){
                var noservice=document.getElementById('noservice');
                console.log(noservice);
                noservice.currentTime = 0;
                noservice.play();
              },100)
              vm.callstyle = "非服务时间";


              axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/opt?visitorMd5Code='+vm.md5+'&flowCfgDetailId=-2').then(function (resp) {
                  console.log('生成结束会话记录')
                  console.log(resp)
                  axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/close?visitorMd5Code='+vm.md5).then(function (resp) {
                    console.log('非服务时间直接结束会话')
                    console.log(resp)
                  })
              })

            }else{
              console.log('提示请求code码为'+data.code);
              vm.callstyle = "服务未开启";
              var noservice=document.getElementById('noservice');
              console.log(noservice);
              setTimeout(function(){
                noservice.currentTime = 0;
                noservice.play();
              },100)
              axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/opt?visitorMd5Code='+vm.md5+'&flowCfgDetailId=-2').then(function (resp) {
                  console.log('生成结束会话记录')
                  console.log(resp)
                  axios.get(vm.baseVisitorUrl+'/visitor/call-center/ivr/flow/session/close?visitorMd5Code='+vm.md5).then(function (resp) {
                    console.log('非服务时间直接结束会话')
                    console.log(resp)
                  })
              })


            }
          }, function (errorMessage) {
            vm.$message.error('网络异常，请稍后再试');
          });
      },
      listreload(id){
        if(id == "notify"){
          this.callkey = [
                  {"key":1,"action":"notify","id":"","teamId":""},
                  {"key":2,"action":"notify","id":"","teamId":""},
                  {"key":3,"action":"notify","id":"","teamId":""},
                  {"key":4,"action":"error","id":"","teamId":""},
                  {"key":5,"action":"error","id":"","teamId":""},
                  {"key":6,"action":"error","id":"","teamId":""},
                  {"key":7,"action":"error","id":"","teamId":""},
                  {"key":8,"action":"error","id":"","teamId":""},
                  {"key":9,"action":"error","id":"","teamId":""},
                  {"key":'*',"action":"error","id":"","teamId":""},
                  {"key":0,"action":"error","id":"","teamId":""},
                  {"key":"#","action":"error","id":"","teamId":""}
          ]
        }else if (id=="record") {
          this.callkey = [
                  {"key":1,"action":"error","id":"","teamId":""},
                  {"key":2,"action":"error","id":"","teamId":""},
                  {"key":3,"action":"error","id":"","teamId":""},
                  {"key":4,"action":"error","id":"","teamId":""},
                  {"key":5,"action":"error","id":"","teamId":""},
                  {"key":6,"action":"error","id":"","teamId":""},
                  {"key":7,"action":"error","id":"","teamId":""},
                  {"key":8,"action":"error","id":"","teamId":""},
                  {"key":9,"action":"error","id":"","teamId":""},
                  {"key":'*',"action":"recordgo","id":"","teamId":""},
                  {"key":0,"action":"error","id":"","teamId":""},
                  {"key":"#","action":"recordend","id":"","teamId":""}
          ]
        }else{
          this.callkey = [
                  {"key":1,"action":"error","id":"","teamId":""},
                  {"key":2,"action":"error","id":"","teamId":""},
                  {"key":3,"action":"error","id":"","teamId":""},
                  {"key":4,"action":"error","id":"","teamId":""},
                  {"key":5,"action":"error","id":"","teamId":""},
                  {"key":6,"action":"error","id":"","teamId":""},
                  {"key":7,"action":"error","id":"","teamId":""},
                  {"key":8,"action":"error","id":"","teamId":""},
                  {"key":9,"action":"error","id":"","teamId":""},
                  {"key":'*',"action":"error","id":"","teamId":""},
                  {"key":0,"action":"error","id":"","teamId":""},
                  {"key":"#","action":"error","id":"","teamId":""}
          ]
        }
     }
    },
    mounted: function () {
      var vm = this;
      //vm.timechange(3700);
      this.md5 = sessionStorage.md5;
      //this.getSatisfySetting();
      this.boxBodyColor = localStorage.boxBodyColor;
      vm.callconnect();
      console.log(vm.$store.state.im.socket)

    },
    beforeMount:function(){
      this.md5 = sessionStorage.md5;
      var vm = this;
      //获取基础配置
        axios.get(this.baseVisitorUrl+'/visitor/call-center/ivr/basic?visitorMd5Code='+vm.md5).then(function (resp) {
            var data  = resp.data;
            if(data.code == 1){
              console.log(data.data)
              data.data.forEach( function(element, index) {
                if(element.type == 1){
                  vm.waitvideo = element.voicePath;
                }else if (element.type == 4) {
                  vm.errorvideo = element.voicePath;
                }else if (element.type == 5) {
                  if(element.playVoice==1){
                    var line =document.getElementById("modevoice");
                    line.src =  element.voicePath;
                  }

                }else if(element.type == 2){
                  var noservice=document.getElementById('noservice');
                  noservice.src =  element.voicePath;
                }else if (element.type == 3) {
                  vm.linevideo = element.voicePath;
                  vm.linetime = element.queueTime;
                  vm.linemmax = element.retryCount;
                }
              });
            }else{
              console.log('提示', '请求code码为'+data.code);
            }
          }, function (errorMessage) {
            vm.$message.error('网络异常，请稍后再试');
          });
    }
  }
</script>

<style scoped>
 .callall{
  width: 640px;
  height: 620px;
  background: #b4dad9;
  overflow: auto;
 }
 .calltop{
  background: #009688;
  color: #fff;
  height: 44px;
  line-height: 44px;
  text-align: center;
  position: relative;
 }
 .callbtn{
  position: absolute;
  left: 10px;
 }
 .callstyle{
  margin-top: 10px;
  text-align: center;
  font-size: 25px;
  margin-bottom: 10px;
 }
 .calltime{
  text-align: center;
  font-size: 20px;
 }
 .callnum{
  margin-top: 18px;
  height: 42px;
  margin-left: 30px;
  width: calc( 100% - 60px);
  font-size: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
 }
 .keyword{
  width: 280px;
  margin: 0 auto;
  overflow: hidden;
 }
 .keyword .mid{
  margin: 0px 35px;
  margin-top: 4px;
 }
 .keyword span{
  width: 70px;
  display: block;
  float: left;
  color: #3f686f;
  font-size: 33px;
  height: 70px;
  text-align: center;
  line-height: 70px;
  margin-top: 4px;
  border-radius: 100%;
 }
 .callclose{
  padding: 10px 0;
 }
 .callclose img{
    display: block;
    margin: 0px auto;
    width: 50px;
    height: 50px;
 }
  .mask {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(96, 96, 96, 0.6);
      z-index: 999;
    }
    .hide {
      position: absolute;
      top: 60px;
      width: 68%;
      left: 16%;
      background-color: #ffffff;
      border: 1px solid #cad0d5;
      border-radius: 3px;
    }
    header {
      height: 44px;
      background-color: #319bf3;
    }
    .headerClose {
      float: right;
    }
    .headerClose img {
      width: 22px;
      height: 22px;
      margin-top: 5px;
      margin-right: 5px;
    }
    .divP {
      padding-top: 14px;
      height: 30px;
      line-height: 30px;
      text-align: center;
    }
    .closeP {
      font-size: 16px;
      color: #ffffff;
    }
</style>



// WEBPACK FOOTER //
// src/components/callcenter/callcenter.vue?0b8b9198